/* eslint-disable */
// /src/pages/TermsPage.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getPolicyOnce } from "../services/policyService";
import PageTopBar from "../components/PageTopBar";

const Wrap = styled.div`
  min-height: 100vh;
  background: #0f1730;
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  flex: 1;
  padding: 20px 16px 40px;
  color: #e9eef8;
  line-height: 1.7;
`;

const Title = styled.h1`
  font-size: 20px;
  margin: 6px 0 14px;
  font-weight: 900;
`;

const Content = styled.pre`
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.7;
  color: #e9eef8;
  white-space: pre-wrap;
`;

const Info = styled.div`
  font-size: 11px;
  color: #9ca3af;
  margin-bottom: 8px;
`;

export default function TermsPage() {
    const [content, setContent] = useState("");
    const [updatedAt, setUpdatedAt] = useState(null);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const data = await getPolicyOnce("termsOfUse");
                if (!alive) return;
                setContent(data.content || "");
                setUpdatedAt(
                    data.updatedAt?.toDate
                        ? data.updatedAt.toDate()
                        : data.updatedAt || null
                );
            } catch (e) {
                console.error("[TermsPage] load error", e);
                if (!alive) return;
                setErr("이용약관을 불러오는 중 오류가 발생했습니다.");
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => {
            alive = false;
        };
    }, []);

    const updatedText = updatedAt
        ? updatedAt.toLocaleString("ko-KR")
        : "저장 이력 없음";

    return (
        <Wrap>
            <Sheet>
                <PageTopBar variant="back" dark label="뒤로" />

                <Body>
                    <Title>이용약관</Title>
                    <Info>마지막 저장 시각: {updatedText}</Info>

                    {loading ? (
                        <Content>이용약관을 불러오는 중입니다…</Content>
                    ) : err ? (
                        <Content>{err}</Content>
                    ) : (
                        <Content>
                            {content || "등록된 이용약관이 없습니다. 관리자에게 문의해 주세요."}
                        </Content>
                    )}
                </Body>
            </Sheet>
        </Wrap>
    );
}
